import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './App.css';

export default function CurrencyDetail() {
  const { id } = useParams();
  const [currency, setCurrency] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/currencies')
      .then(res => res.json())
      .then(data => {
        const found = data.find(c => String(c.id) === String(id));
        setCurrency(found);
      });
  }, [id]);

  if (!currency) return <div style={{ padding: 32 }}>Currency not found.</div>;

  return (
    <div className="currency-detail-page">
      <div style={{ marginBottom: 16 }}>
        <Link to="/" className="nav-link">Accueil</Link> |
        <Link to="/currencies" className="nav-link">All Currencies</Link>
      </div>
      <div className="currency-card" style={{ maxWidth: 350, margin: '0 auto' }}>
        <div className="currency-info">
          <div className="currency-code">{currency.code}</div>
          <div className="currency-name">{currency.name}</div>
          <div className="currency-rate">{currency.conversionRate}</div>
        </div>
      </div>
      <button style={{ marginTop: 24 }} onClick={() => navigate(-1)} className="nav-link">Back</button>
    </div>
  );
}
